import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NotificationBell.module.css";

function getNotificationPath(notification) {
  const { type, jobId } = notification;
  if (jobId) return `/jobs/${jobId}`;
  switch (type) {
    case "officer_approved": return "/profile";
    default: return null;
  }
}

export default function NotificationBell({ notifications, unreadCount, onMarkRead, onMarkAllRead }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const formatTime = (ts) => {
    if (!ts) return "";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    const now = new Date();
    const diff = now.getTime() - d.getTime();
    if (diff < 60000) return "Just now";
    if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
    return d.toLocaleDateString();
  };

  const typeLabel = (type) => {
    switch (type) {
      case "job_posted": return "NEW";
      case "signup_confirmed": return "OK";
      case "waitlist_promoted": return "UP";
      case "job_cancelled": return "X";
      case "attendance_recorded": return "ATT";
      case "officer_approved": return "OK";
      default: return "i";
    }
  };

  return (
    <div className={styles.wrapper}>
      <button className={styles.bellBtn} onClick={() => setOpen(!open)} aria-label="Notifications">
        <span className={styles.bellIcon}>&#128276;</span>
        {unreadCount > 0 && (
          <span className={styles.badge}>{unreadCount > 99 ? "99+" : unreadCount}</span>
        )}
      </button>

      {open && (
        <>
          <div className={styles.backdrop} onClick={() => setOpen(false)} role="presentation" aria-hidden="true" />
          <div className={styles.dropdown}>
            <div className={styles.header}>
              <span className={styles.headerTitle}>Notifications</span>
              {unreadCount > 0 && (
                <button className={styles.markAllBtn} onClick={onMarkAllRead}>
                  Mark all read
                </button>
              )}
            </div>
            <div className={styles.list}>
              {notifications.length === 0 ? (
                <div className={styles.empty}>
                  <span className={styles.emptyIcon}>&#128276;</span>
                  No notifications yet.
                </div>
              ) : (
                notifications.slice(0, 50).map((n) => {
                  const path = getNotificationPath(n);
                  const handleActivate = () => {
                    if (!n.read) onMarkRead(n.id);
                    if (path) {
                      navigate(path);
                      setOpen(false);
                    }
                  };
                  return (
                    <div
                      key={n.id}
                      className={`${styles.item} ${!n.read ? styles.itemUnread : ""} ${path ? styles.itemClickable : ""}`}
                      onClick={handleActivate}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleActivate();
                        }
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <span className={n.read ? styles.readDot : styles.unreadDot} />
                      <div className={styles.itemContent}>
                        <p className={styles.itemTitle}>{n.title}</p>
                        <p className={styles.itemMsg}>{n.message}</p>
                        <div className={styles.itemMeta}>
                          <span className={styles.typeTag}>{typeLabel(n.type)}</span>
                          <span className={styles.time}>{formatTime(n.createdAt)}</span>
                          {path && <span className={styles.viewLink}>View &rarr;</span>}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
